import React from "react";
import { Menu, Layout, Divider } from "antd";
import {
  UserOutlined,
  NotificationOutlined,
  HomeOutlined,
  TableOutlined,
  ContactsOutlined,
  SyncOutlined,
  FileTextOutlined,
  LogoutOutlined,
} from "@ant-design/icons";
import {
  CircleQuestionMark,
  FolderClock,
  NotebookText,
  Grid3x3,
  FilePlus,
  CalendarDays,
  CalendarSync,
  BicepsFlexed,
} from "lucide-react";
import { useNavigate, useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import useUsuario from "../../../core/hooks/UseUsuario";
import { RoundButton } from "../../components/RoundButton/RoundButton";
import { Resolucao } from "../../../sdk/@types";

const { Sider } = Layout;
const { SubMenu } = Menu;

interface SidebarProps {
  questions? : Resolucao.ResolucaoQuestao[]
  collapsed: boolean;
  resolucao?: Resolucao.ResolucaoQuestao;
  onClick?: (index: number) => void;
}

export default function SimuladoSidebar({ collapsed, questions, resolucao, onClick }: SidebarProps) {
  const navigate = useNavigate();
  const location = useLocation();

  const { usuario } = useUsuario();

  const handleSituation = (item:Resolucao.ResolucaoQuestao):'default'|'answered'|'focused' => {
    if (resolucao === item) return 'focused';
    if (item.answer) return 'answered';
    return 'default';
  }

  return (
    <Sider
      width={100}
      collapsible
      collapsed={collapsed}
      trigger={null}
      className="site-layout-background"
      breakpoint="lg"
      collapsedWidth="0"
    >
      <div className="flex flex-col items-center  gap-2 overflow-y-auto h-[100%]">
        {
          questions?.map((item, index) => (
            <RoundButton
              onClick={() => onClick?.(index)}
              key={index}
              label={(index + 1).toString()}
              size="large"
              situation={handleSituation(item)}
            />
          ))
        }
      </div>
    </Sider>
  );
}
